import { useToast } from "@chakra-ui/react";
import axios from "axios";
import React, { useState } from "react";
import { useSelector } from "react-redux";

const initState = {
  role: "",
  reason: "",
};

const UpgradeRole = () => {
  const { user } = useSelector((state) => state.auth);
  const [formDataValues, setFormDataValues] = useState(initState);
  const toast = useToast();
  // console.log("formData", formDataValues);
  const handleChange = (e) => {
    setFormDataValues({
      ...formDataValues,
      [e.target.id]: e.target.value,
      role_requested: formDataValues.role,
    });
  };

  const backendURL = "https:/3.6.130.138.nip.io/v1";

  const handleSubmitRequest = async (e) => {
    // on submit, a request will be sent to admin, and admin will be able to see the request in admin panel
    // admin will be able to accept or reject the request
    // if accepted, then the user's role will be upgraded
    // if rejected, then the user will be notified
    e.preventDefault();
    if (formDataValues.role === "") {
      toast({
        title: "Error",
        description: "Please select a role",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }
    if (formDataValues.reason === "") {
      toast({
        title: "Error",
        description: "Please enter a reason",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }
    const url = `https:/3.6.130.138.nip.io/v1/user/upgrade/`;
    const data = {
      ...formDataValues,
      user_id: user._id,
    };
    let res = await axios.post(url, data);
    console.log("res", res);
    if (res.status === 200) {
      setFormDataValues(initState);
      toast({
        title: "Request sent",
        description: "Your request has been sent to admin",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } else {
      toast({
        title: "Error",
        description: "Something went wrong",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <div className="w-full flex flex-col h-[80vh] justify-center">
      {/* upgrade role form for user */}
      {/* Card of 2xl size */}
      {/* 2 inputs, role and reason for upgrade */}
      {/* if current role is viewer, then options will be planner and admin, else if current role is planner, then option will be admin by default. */}
      {/* 1 button, submit request */}
      {/* on submit, a request will be sent to admin, and admin will be able to see the request in admin panel */}
      {/* admin will be able to accept or reject the request */}
      {/* if accepted, then the user's role will be upgraded */}
      {/* if rejected, then the user will be notified */}
      <div className="flex flex-col items-center justify-center w-[90%]">
        <div className="w-full max-w-2xl">
          <p className="text-2xl text-center my-2 font-bold">Upgrade Role</p>
          <form className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
            <div className="mb-4">
              <label
                className="block text-gray-700 text-sm font-bold mb-2"
                htmlFor="role"
              >
                Select Your Role
              </label>
              <select
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="role"
                onChange={handleChange}
                value={formDataValues.role}
              >
                <option value={""}>Select Role</option>
                {
                  // if current role is viewer, then options will be planner and admin, else if current role is planner, then option will be admin by default.
                  user.role === "viewer" ? (
                    <>
                      <option value="planner">Planner</option>
                      <option value="admin">Admin</option>
                    </>
                  ) : (
                    <option value="admin">Admin</option>
                  )
                }
              </select>
            </div>
            <div className="mb-6">
              <label
                className="block text-gray-700 text-sm font-bold mb-2"
                htmlFor="reason"
              >
                Reason for upgrade
              </label>
              <textarea
                value={formDataValues.reason}
                onChange={handleChange}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="reason"
                rows="3"
              ></textarea>
            </div>
            <div className="flex items-center justify-between">
              <button
                onClick={handleSubmitRequest}
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                type="button"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpgradeRole;
